import { automationRunChildrenUrl } from "../constants/automation-api-urls";
import type { IAutomationChildRun } from "../types";
import type { ApiClient } from "./client";

// NOTE: NSAI-7883 — run reads that are not tied to one automation kind: the
// runs a run started can be scheduled agents and workflows alike.
export class AutomationRunApi {
  constructor(private apiClient: ApiClient) {}

  async getChildRuns(runUuid: string): Promise<IAutomationChildRun[]> {
    const response = await this.apiClient.get<IAutomationChildRun[]>(
      automationRunChildrenUrl(runUuid),
    );
    return response.data;
  }
}
